<template>
  <ya-site-resource-list resource="statement" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteReconciliationOrderList',
  components: { YaSiteResourceList },
}
</script>
